// extracted by css-extract-rspack-plugin
export default {"root":"root--Lzr2ec3N22cjEplb","containerIcon":"container-icon--SR_diZPP9eo5Y0hc","wrapperIcon":"wrapper-icon--eJ8cBjS3G2IkRzCd","loading":"loading--VVWks8xfxec6ZnnL"};